import { PATH_NAMES } from '@components/pages/shared';
import { useMemo } from 'react';

export const useOrderItems = () => {
  const items = useMemo(
    () => [
      {
        label: 'All Orders',
        to: PATH_NAMES.ROOT,
        id: PATH_NAMES.ROOT,
      },
      {
        label: 'Submitted',
        to: PATH_NAMES.orderListView.SUBMITTED,
        id: PATH_NAMES.orderListView.SUBMITTED,
      },
      {
        label: 'On Hold',
        to: PATH_NAMES.orderListView.ON_HOLD,
        id: PATH_NAMES.orderListView.ON_HOLD,
      },
      {
        label: 'Scheduled',
        to: PATH_NAMES.orderListView.SCHEDULED,
        id: PATH_NAMES.orderListView.SCHEDULED,
      },
      {
        label: 'Picked Up',
        to: PATH_NAMES.orderListView.PICKED_UP,
        id: PATH_NAMES.orderListView.PICKED_UP,
      },
      {
        label: 'Delivered',
        to: PATH_NAMES.orderListView.DELIVERED,
        id: PATH_NAMES.orderListView.DELIVERED,
      },
      {
        label: 'Canceled',
        to: PATH_NAMES.orderListView.CANCELED,
        id: PATH_NAMES.orderListView.CANCELED,
      },
    ],
    [],
  );

  return items;
};
